import { getFullName } from './getFullName';

import { ROLE_NAME } from 'enums';
import { IAccountUserResponse } from 'services/account/account.interface';
import { ICompanyMemberUser } from 'views/pages/CompanyMembers/company-members.interface';

function convertToCompanyMembersTable(
  accounts: IAccountUserResponse[],
): ICompanyMemberUser[] {
  return accounts
    .filter(account => account?.role.name !== ROLE_NAME.UNAPPROVED)
    .map(
      ({
        photoUrl,
        email,
        firstName,
        lastName,
        id,
        position,
        targetPosition,
        expertise,
        department,
        unit,
      }) => ({
        photoUrl,
        email,
        name: getFullName(firstName, lastName),
        id,
        position: position ? position.name : '-',
        targetPosition: targetPosition ? targetPosition.name : '-',
        expertise: expertise ? expertise.name : '-',
        expertiseId: expertise?.id ?? null,
        department: department ? department.name : '-',
        departmentId: department?.id ?? null,
        unit: unit ? unit.name : '-',
        unitId: unit?.id ?? null,
      }),
    );
}

export { convertToCompanyMembersTable };
